import { render, staticRenderFns } from "./Step3Confirm.vue?vue&type=template&id=06b890c2&"
import script from "./Step3Confirm.vue?vue&type=script&lang=js&"
export * from "./Step3Confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Step3Confirm.vue"
export default component.exports